import React from "react";
import { ProductionJobStatus } from "../models/enums/production-job-status";
import { CellType } from "../models/shared/metric-base";

interface ICellProps {
    className: any;
    disabled: any;
    beingSelected: any;
    selected: any;
    onTouchStart: any;
    onTouchMove: any;
    style?: any;
    type: CellType;
    status: ProductionJobStatus;
    value: any;
    showonlyquantites: boolean|undefined;
}

export class DragCell extends React.Component<ICellProps> {

    public td : any;

    /**
     * Only actually redraw when a few properties change to increase perf
     * @param nextProps the incoming next values
     * @returns 
     */
    public shouldComponentUpdate(nextProps: any) {
        return this.props.beingSelected !== nextProps.beingSelected ||
               this.props.selected !== nextProps.selected || 
               this.props.status !== nextProps.status || 
               this.props.value !== nextProps.value;
    }

    public componentDidMount = () => {
        // We need to call addEventListener ourselves so that we can pass
        // {passive: false}
        this.td.addEventListener("touchstart", this.handleTouchStart, {
            passive: false
        });
        this.td.addEventListener("touchmove", this.handleTouchMove, {
            passive: false
        });
    }

    public componentWillUnmount = () => {
        this.td.removeEventListener("touchstart", this.handleTouchStart);
        this.td.removeEventListener("touchmove", this.handleTouchMove);
    }

    public getCellContent() {

        // A disabled cell is the space between the groups of metrics, which has nothing to show.  It is not a metric
        // that has no data, so it has no dash either.
        if (this.props.disabled) {
            return null;
        }

        if (this.props.type === CellType.Property) {
            return this.props.value;
        }

        if (this.props.type === CellType.Metric) {

            if (this.props.showonlyquantites === true) {
                return this.props.value === 0 ? <span className="no-data">-</span> : this.props.value;
            }

            switch (this.props.status) {
                case ProductionJobStatus.Open:
                    return <div className="schedule-status open-bg" />;
                case ProductionJobStatus.Printed:
                    return <div className="schedule-status printed-bg" />;
                case ProductionJobStatus.Complete:
                    return <div className="schedule-status complete-bg" />;
                default:
                    return <span className="no-data">-</span>;
            }
        }
    };

    public render = () => {
        let {
            className = "",
            disabled,
            beingSelected,
            selected,
            onTouchStart,
            onTouchMove,
            showonlyquantites,
            ...props
        } = this.props;

        if (disabled) {
            className += " dragcell ell-disabled";
        } else {
            className += " dragcell cell-enabled";
            if (selected) {
                className += " cell-selected";
            }
            if (beingSelected) {
                className += " cell-being-selected";
            }
        }
        return (
            <td
                ref={(td) => (this.td = td)}
                className={className}
                onMouseDown={this.handleTouchStart}
                onMouseMove={this.handleTouchMove}
                {...props}
            >
               { this.getCellContent() }
            </td>
        );
    }

    public handleTouchStart = (e: any) => {
        if (!this.props.disabled) {
            this.props.onTouchStart(e);
        }
    }

    public handleTouchMove = (e: any) => {
        if (!this.props.disabled) {
            this.props.onTouchMove(e);
        }
    }
}
